module.exports = __webpack_public_path__ + "img/bannerInterno.38d2155c.webp";